import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import styles from './formComplete.module.scss';

function ListTable({ question, removeRow, isDisabled }) {
  const columns = question.options.concat([{ field: 'actions', header: 'Actions', hidden: isDisabled,
    body: (item, tableInfo) => <div className={styles['actions']}><Button type="button" onClick={()=>removeRow(tableInfo.rowIndex, question.name)} className='remove-button' label='Remove'/></div> }]);
  return <div className={styles['data-table']}>
    <DataTable value={question.value} loading={false} showGridlines className={styles['fullWidth']}>
      {columns.map(column => <Column {...column} key={column.header}></Column>)}
    </DataTable>
  </div>;
}

ListTable.propTypes = {
  removeRow: PropTypes.func,
  question: PropTypes.object,
  isDisabled: PropTypes.bool,
};

export default ListTable;
